import { Helmet } from 'react-helmet'
import React from 'react'
import PropTypes from 'prop-types'

const LanguageListener = ({ lang }) => (
  <Helmet>
    <html lang={lang} dir={lang === 'ar' ? 'rtl' : 'ltr'} />
  </Helmet>
)

LanguageListener.propTypes = {
  lang: PropTypes.string.isRequired,
}

export default LanguageListener
